/**
 * Safely parse data to JSON:
 * - If the input is a string, it attempts to parse it as JSON.
 * - If the input is an object, it returns the object as is.
 * - If the input is undefined or cannot be parsed, it returns undefined.
 */
export function safeParseJson<T = Record<string, unknown>>(
  data: string | object | undefined
): T | undefined {
  try {
    return typeof data === 'string'
      ? // string: parse it to JSON
        JSON.parse(data)
      : typeof data === 'object'
        ? // object: use it as is
          data
        : // unknown: undefined
          undefined;
  } catch {
    return undefined;
  }
}
